import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { Subtotal } from "@redotech/redo-customer-portal-shared/types";
import ChevronDownSvg from "@redotech/redo-icons/chevron-down.svg";
import ChevronUpSvg from "@redotech/redo-icons/chevron-up.svg";
import { memo, useState } from "react";
import * as indentedTotalsCss from "./indented-totals.module.css";

export const IndentedTotals = memo(function IndentedTotals({
  title,
  total,
  subtotals,
  currencyFormatter,
}: {
  title: string;
  total: number;
  subtotals?: Subtotal[];
  currencyFormatter: Intl.NumberFormat;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const canExpand = !!subtotals && subtotals.length > 0;

  return (
    <Flex
      className={indentedTotalsCss.totalsContainer}
      flexDirection="column"
      gap="2xl"
      pt="xs"
    >
      <Flex
        align="center"
        className={indentedTotalsCss.totalsHeader}
        flexDirection="row"
        justify="space-between"
      >
        {canExpand ? (
          <button
            aria-expanded={isExpanded}
            aria-label={title}
            className={indentedTotalsCss.accordionToggle}
            onClick={() => setIsExpanded(!isExpanded)}
            type="button"
          >
            <Text fontSize="sm" textColor="primary">
              {title}
            </Text>
            {isExpanded ? (
              <ChevronUpSvg height={14} width={14} />
            ) : (
              <ChevronDownSvg height={14} width={14} />
            )}
          </button>
        ) : (
          <Text fontSize="sm" textColor="primary">
            {title}
          </Text>
        )}
        <Text fontSize="sm" textColor="secondary">
          {currencyFormatter.format(total)}
        </Text>
      </Flex>
      {isExpanded && subtotals && (
        <>
          {subtotals.map((subtotal, i) => (
            <Flex flexDirection="row" justify="space-between" key={i} pl="xl">
              <Text fontSize="sm" textColor="secondary">
                {subtotal.title}
              </Text>
              <Text fontSize="sm" textColor="secondary">
                {currencyFormatter.format(subtotal.total)}
              </Text>
            </Flex>
          ))}
        </>
      )}
    </Flex>
  );
});
